<template>
  <div id="pageRomaneios">
    <v-snackbar
      v-model="snackbar.show"
      :bottom="snackbar.y === 'bottom'"
      :color="snackbar.color"
      :left="snackbar.x === 'left'"
      :multi-line="snackbar.mode === 'multi-line'"
      :right="snackbar.x === 'right'"
      :timeout="snackbar.timeout"
      :top="snackbar.y === 'top'"
      :vertical="snackbar.mode === 'vertical'"
    >
      {{ snackbar.text }}
      <v-btn dark text @click="snackbar.show = false">Fechar</v-btn>
    </v-snackbar>

    <v-container fluid>
      <v-row justify="center">
        <v-col cols="12" md="8" lg="7">
          <v-form ref="form" v-model="form.valid" lazy-validation>
            <v-card>
              <v-card-text>
                <h1 class="text-center">Dados do usuário</h1>
                <v-row>
                  <v-col>
                    <v-text-field
                      v-model="user.name"
                      :counter="form.name.counter.count"
                      :rules="form.name.rules"
                      :error="form.name.error"
                      :error-messages="form.name.message"
                      label="Nome"
                      required
                    ></v-text-field>
                    <v-text-field
                      v-model="user.email"
                      :counter="form.email.counter.count"
                      :rules="form.email.rules"
                      :error="form.email.error"
                      :error-messages="form.email.message"
                      label="E-mail"
                      required
                    ></v-text-field>
                    <v-text-field
                      v-model="user.phone"
                      v-mask="form.phone.mask"
                      :rules="form.phone.rules"
                      :error="form.phone.error"
                      :error-messages="form.phone.message"
                      label="Celular"
                      required
                    ></v-text-field>
                    <v-text-field
                      @keydown="resetCpfError"
                      v-model="user.cpf"
                      v-mask="form.cpf.mask"
                      :rules="form.cpf.rules"
                      :error="form.cpf.error"
                      :error-messages="form.cpf.message"
                      label="CPF"
                      required
                    ></v-text-field>
                    <v-col sm="12">
                      <h2 class="text-left">Perfis</h2>
                      <v-switch
                        v-for="profile in profiles"
                        v-model="user.profiles"
                        @change="profileChange(profile)"
                        :label="profile.name"
                        :value="profile.value"
                        :key="'switch' + profile.value"
                        hide-details
                      ></v-switch>
                    </v-col>
                  </v-col>
                </v-row>

                <v-row justify="center">
                  <v-col sm="8" md="6" lg="2">
                    <v-btn
                      :disabled="!form.valid"
                      @click="manageUser(user)"
                      class="ma-1"
                      block
                      color="success"
                      :loading="loading"
                      >Salvar</v-btn
                    >
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-form>
        </v-col>
        <v-col cols="12" md="8" lg="7">
          <v-card>
            <v-card-text>
              <v-btn
                color="pink"
                dark
                small
                absolute
                top
                right
                fab
                @click="getIndustries"
              >
                <v-icon>add</v-icon>
              </v-btn>
              <h2>Indústrias</h2>
              <v-row>
                <v-col></v-col>
              </v-row>
              <p v-if="user.industries && user.industries.length < 1">
                Nenhuma Indústria encontrado para esse usuário.
              </p>
              <v-row
                v-else
                v-for="industry in user.industries"
                :key="'industry' + industry.id"
              >
                <v-col cols="1">{{ industry.industry_id }}</v-col>
                <v-col cols="9">{{ industry.industry.name }}</v-col>
                <v-col cols="2">
                  <v-btn
                    @click="confirmDeleteIndustry(industry)"
                    icon
                    small
                    color="red"
                  >
                    <v-icon>fa-trash</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="8" lg="7">
          <v-card>
            <v-card-text>
              <h2>Plugins</h2>

              <v-switch
                v-for="(plugin, idx) in plugins"
                v-model="plugin.is_active"
                :value="plugin.is_active"
                :label="plugin.description"
                :key="idx"
                @change="enabledPluginsButton(idx)"
                hide-details
              ></v-switch>

              <v-row justify="center">
                <v-col sm="8" md="6" lg="2">
                  <v-btn
                    :disabled="pluginsButtonDisable"
                    @click="savePluginsChanges"
                    class="ma-1"
                    block
                    color="success"
                    :loading="pluginsLoading"
                    >Salvar</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <app-confirm-modal
        :dialog="dialogDeleteIndustry.open"
        :message="dialogDeleteIndustry.text"
        :loading="dialogDeleteIndustry.loading"
        v-on:choose="disableIndustry"
      ></app-confirm-modal>

      <v-dialog v-model="dialogAddIndustry.open" width="500">
        <v-card>
          <v-card-title class="headline info white--text" primary-title
            >Adicionar permissão de industria</v-card-title
          >

          <v-card-text>
            <v-row
              v-for="industry in dialogAddIndustry.industries"
              :key="'industry' + industry.id"
            >
              <v-col cols="1">{{ industry.id }}</v-col>
              <v-col>{{ industry.name }}</v-col>
              <v-col>
                <v-btn
                  :loading="dialogAddIndustry.loading"
                  @click="addIndustry(industry)"
                  small
                  color="primary"
                  >Adicionar</v-btn
                >
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn text @click="dialogAddIndustry.open = false">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import appApi from "../../plugins/api";
import ConfirmModal from "../../components/ConfirmModal";

export default {
  components: {
    "app-confirm-modal": ConfirmModal
  },
  data: function() {
    return {
      loading: false,
      snackbar: {},
      dialogDeleteIndustry: {
        open: false,
        text: "",
        industry: null,
        loading: false
      },
      dialogAddIndustry: {
        open: false,
        loading: false,
        industries: []
      },
      user: {},
      profiles: [
        { name: "Administrador", value: "admin" },
        { name: "Usuário Portal", value: "user" },
        { name: "Industria", value: "industry" }
      ],
      plugins: [
        {
          plugin_id: 1,
          name: "abate_online",
          is_active: false,
          description: "Abate ao Vivo"
        }
      ],
      pluginsLabels: [],
      pluginsButtonDisable: true,
      pluginsLoading: false,
      form: {
        valid: true,
        name: {
          error: false,
          message: "",
          rules: [
            v => !!v || "Nome é necessário",
            v =>
              (v && v.length <= 255) ||
              "Nome precisa ter menos de 255 caracteres"
          ],
          counter: {
            count: 255
          }
        },
        email: {
          error: false,
          message: "",
          rules: [
            v => !!v || "E-mail é necessário",
            v => /.+@.+\..+/.test(v) || "E-mail precisa ser válido",
            v =>
              (v && v.length <= 255) ||
              "E-mail precisa ter menos de 255 caracteres"
          ],
          counter: {
            count: 255
          }
        },
        phone: {
          error: false,
          message: "",
          mask: "+ ## (##) #####-####",
          rules: [v => !!v || "Telefone é necessário"]
        },
        cpf: {
          error: false,
          message: "",
          mask: "###.###.###-##",
          rules: [v => !!v || "CPF é necessário"]
        }
      }
    };
  },

  mounted: function() {
    window.scrollTo(0, 0);

    if (this.$route.params.id) {
      this.getUser(this.$route.params.id);
      this.getUserPlugins();
    } else {
      this.$router.push({ name: "NotFound" });
    }
  },

  methods: {
    getUserPlugins() {
      appApi
        .getPluginsUsers({ user_id: this.$route.params.id })
        .then(({ data: userPlugins = [] }) => {
          for (const plugin of userPlugins) {
            const foundIndex = this.plugins.findIndex(
              p => p.plugin_id == plugin.plugin_id
            );
            if (foundIndex === -1) this.plugins.splice(foundIndex, 1);
            else this.plugins[foundIndex] = plugin;
          }

          this.plugins = this.plugins.map(p => ({
            ...p,
            is_active: (p.is_active && true) || false
          }));
        });
    },

    savePluginsChanges() {
      this.pluginsLoading = true;

      this.plugins = this.plugins.map(p => ({
        ...p,
        is_active: (p.is_active && true) || false
      }));

      appApi
        .postPluginsUsers({
          plugins: this.plugins,
          user_id: this.$route.params.id
        })
        .then(result => {
          this.snackbar = {
            show: true,
            x: "right",
            y: "bottom",
            text: "Plugins alterados com sucesso",
            timeout: 3000,
            color: "success",
            mode: "multi-line"
          };
          this.pluginsLoading = false;
          this.pluginsButtonDisable = true;
        })
        .catch(error => {
          this.snackbar = {
            show: true,
            x: "right",
            y: "bottom",
            text: "Erro ao salvar alterações nos plugins",
            timeout: 3000,
            color: "error",
            mode: "multi-line"
          };
          console.log(error);
        });
    },

    enabledPluginsButton(idx) {
      if (this.pluginsButtonDisable)
        this.pluginsButtonDisable = !this.pluginsButtonDisable;
    },

    resetCpfError: function() {
      this.form.cpf.error = false;
      this.form.cpf.message = "";
    },

    manageUser: function(user) {
      if (this.$refs.form.validate()) {
        this.loading = true;
        appApi
          .updateUserProfile(user)
          .then(r => {
            this.snackbar = {
              show: true,
              x: "right",
              y: "bottom",
              text: "Usuário atualizado com sucesso",
              timeout: 3000,
              color: "success",
              mode: "multi-line"
            };

            this.loading = false;
          })
          .catch(e => {
            this.loading = false;
            if (e.response.status == 400) {
              e.response.data.forEach(element => {
                this.form[element.field].error = true;
                this.form[element.field].message = "Valor inválido";
              });
            }
          });
      }
    },

    profileChange(change) {
      if (this.user.profiles.indexOf(change.value) !== -1) {
        appApi.putUserProfile({
          user_id: this.user.id,
          profile: change.value
        });
      } else {
        appApi.deleteUserProfile({
          user_id: this.user.id,
          profile: change.value
        });
      }
    },

    getUser: function(id) {
      appApi
        .getUser(id)
        .then(result => {
          this.user = result.data;
        })
        .catch(error => {
          console.log("error", error);
          this.$router.push({ name: "NotFound" });
        });
    },

    confirmDeleteIndustry(industry) {
      this.dialogDeleteIndustry.industry = industry;
      this.dialogDeleteIndustry.open = true;
      this.dialogDeleteIndustry.loading = false;
      this.dialogDeleteIndustry.text =
        "Tem certeza que deseja remover " + industry.industry.name + "?";
    },

    disableIndustry(opt) {
      if (!opt) {
        this.dialogDeleteIndustry.open = false;
      }
      this.dialogDeleteIndustry.loading = true;
      appApi
        .deleteUserIndustry(this.dialogDeleteIndustry.industry.id)
        .then(result => {
          this.getUser(this.$route.params.id);
          this.dialogDeleteIndustry.open = false;
        })
        .catch(error => {
          this.getUser(this.$route.params.id);
          this.dialogDeleteIndustry.open = false;
        });
    },

    getIndustries() {
      this.dialogAddIndustry.open = true;
      appApi.getIndustries().then(result => {
        this.dialogAddIndustry.industries = result.data.data;
      });
    },

    addIndustry(industry) {
      this.dialogAddIndustry.loading = true;
      appApi
        .postUserIndustry({ industry_id: industry.id, user_id: this.user.id })
        .then(result => {
          this.dialogAddIndustry.loading = false;
          this.dialogAddIndustry.open = false;
          this.getUser(this.user.id);
        })
        .catch(error => {
          this.dialogAddIndustry.loading = false;
          this.dialogAddIndustry.open = false;
          this.getUser(this.user.id);
        });
    }
  }
};
</script>
<style scoped lang="css">
>>> .v-data-table-header.v-data-table-header-mobile {
  display: none;
}
</style>
